export default __webpack_public_path__ + "static/media/Ballroll_00042.8efde4b6.png";